import React, { useState, useEffect } from "react";
import SummaryCard from './summary-card/summary-card';
import * as jobService from './services/jobs-service';
import * as revenueCalculator from './services/revenue-calculator';
import DraggableJobList from "./job-list/draggable-job-list";
import { Container, Typography, Paper } from '@material-ui/core';
import { useParams } from "react-router-dom";

export const EngineerApp = () => {
    const today = new Date();

    let params = useParams();

    let engineerIdParam;

    if (params.engineerId) {
        engineerIdParam = Number(params.engineerId);
    }

    const [engineerId, setEngineerId] = useState(engineerIdParam);
    const [currentDate, setCurrentDate] = useState(today);
    const [pendingJobs, setPendingJobs] = useState([]);
    const [completedJobs, setCompletedJobs] = useState([]);
    const [projectedRevenue, setProjectedRevenue] = useState(0);
    const [realisedRevenue, setRealisedRevenue] = useState(0);

    useEffect(() => {
        if (engineerId > 0) {
            initDayJobsForEngineer(engineerId, currentDate);
        } 
    }, [engineerId, currentDate]);

    const selectEngineer = (engineer) => {
        setEngineerId(engineer.id);
    }

    const changeDay = (selectedDate) => {
        initDayJobsForEngineer(engineerId, selectedDate);
        setCurrentDate(selectedDate);
    }

    const initDayJobsForEngineer = (engineerId, date) => {
        jobService.getDayJobsForEngineer(engineerId, date)
            .then((jobs) => {
                const pendingJobs = jobs.filter(j => j.status === 0);
                const completedJobs = jobs.filter(j => j.status === 2);

                setPendingJobs(pendingJobs);
                setCompletedJobs(completedJobs);
                setProjectedRevenue(revenueCalculator.calculate(pendingJobs));
                setRealisedRevenue(revenueCalculator.calculate(completedJobs));
            });
    }

    const updateJobPosition = (currentIndex, newIndex) => {
        let jobs = Array.from(pendingJobs);

        const [removed] = jobs.splice(currentIndex, 1);
        jobs.splice(newIndex, 0, removed);

        jobs.forEach((job, index) => job.position = index);

        setPendingJobs(jobs);

        jobService.updateJobPositions(jobs, engineerId);
    }

    const markJobComplete = (job) => {
        jobService.markJobComplete(job.id, engineerId)
            .then(() => {

                job.status = 2;

                const tempCompletedJobs = completedJobs;
                tempCompletedJobs.push(job);

                const tempPendingJobs = pendingJobs.filter(j => j.id !== job.id);

                setPendingJobs(tempPendingJobs);
                setCompletedJobs(tempCompletedJobs);
                setProjectedRevenue(revenueCalculator.calculate(tempPendingJobs));
                setRealisedRevenue(revenueCalculator.calculate(tempCompletedJobs));
            })
            .catch(error => {
                const friendlyMessage = "An error occured when trying to mark job complete";
                console.error(friendlyMessage + error.message);
                alert(friendlyMessage);
            });
    };

    return (
        <div>
            <SummaryCard
                onChangeDay={changeDay}
                currentDate={currentDate}
                realisedRevenue={realisedRevenue}
                projectedRevenue={projectedRevenue}
                engineerId={engineerId}
                onSelectEngineer={selectEngineer} />
            {pendingJobs && pendingJobs.length >= 1
                ? <Paper>
                    <DraggableJobList
                        jobs={pendingJobs}
                        onMarkJobComplete={markJobComplete}
                        onJobsReordered={updateJobPosition} />
                </Paper>
                : <Container className="center">
                    <Typography variant="h5" component="h2">No Jobs To Do</Typography>
                </Container>}
        </div>);
}